<script setup lang="ts">
import { useTopicsQuery } from '~~/src/composables/query/topic/useTopicsQuery'

const props = defineProps<{
  search: string
}>()

const search = toRef(props, 'search')

const { data: topics } = useTopicsQuery({
  query: {},
})

const filteredTopics = computed(() => {
  return (search.value
    ? topics.value?.filter((topic) => {
      return topic.name.toLowerCase().includes(search.value.toLowerCase())
    })
    : topics.value) ?? []
})
</script>

<template>
  <AppTab name="Topics" :count="filteredTopics?.length" overflow-auto>
    <PromptTopicList :topics="filteredTopics ?? []" />
  </AppTab>
</template>
